import { render, staticRenderFns } from "./step-one.vue?vue&type=template&id=38908146&scoped=true&"
import script from "./step-one.vue?vue&type=script&lang=js&"
export * from "./step-one.vue?vue&type=script&lang=js&"
import style0 from "./step-one.vue?vue&type=style&index=0&id=38908146&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38908146",
  null
  
)

export default component.exports